import React from 'react';
import BaseBadge from './BaseBadge';

const WORK_EXAMPLES = [
  {
    label: 'Quality Assurance Systems',
    descriptor: 'Hierarchical QA gates, traveler tracking, sign-off workflows',
  },
  {
    label: 'Financial Estimators',
    descriptor: 'Phase calculations, 30-year projections, account exec tools',
  },
  {
    label: 'Lead Capture Systems',
    descriptor: 'Smart intake forms with Google Sheets storage',
  },
];

const AboutBadge = ({ onSeePortfolio }) => (
  <BaseBadge title="Tower">
    <div className="flex flex-col gap-5 flex-grow">

      {/* Zone 1 — Headline */}
      <div className="flex flex-col gap-2">
        <h3 className="text-[22px] font-bold leading-tight tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-blue-400">
          Stop Renting Your Competitive Edge.
        </h3>
        <p className="text-[13px] text-white/55 leading-relaxed">
          The era of settling for generic SaaS is over. Your software should be
          as unique as your business.
        </p>
      </div>

      {/* Zone 2 — Narrative */}
      <div className="text-[13px] text-white/75 leading-relaxed">
        <p>
          We build custom, purpose-driven software designed exclusively for
          your operations. No licensing fees. No feature bloat. Built for you,
          owned by you.
        </p>
      </div>

      {/* Zone 3 — Work Examples */}
      <div className="flex flex-col gap-2.5 flex-grow">
        {WORK_EXAMPLES.map(({ label, descriptor }) => (
          <button
            key={label}
            onClick={onSeePortfolio}
            disabled={!onSeePortfolio}
            className={`w-full text-left flex items-start gap-3 pl-3 border-l-2 border-cyan-400/30 group transition-all duration-200 ${
              onSeePortfolio
                ? 'cursor-pointer hover:border-cyan-400/70'
                : 'cursor-default'
            }`}
          >
            <div className="flex flex-col min-w-0">
              <span className="text-[13px] font-semibold text-white/90 leading-snug group-hover:text-white transition-colors">
                {label}
              </span>
              <span className="text-[12px] text-white/40 leading-snug mt-0.5 group-hover:text-white/55 transition-colors">
                {descriptor}
              </span>
            </div>
            {onSeePortfolio && (
              <svg
                className="w-3.5 h-3.5 mt-1 shrink-0 text-white/20 group-hover:text-cyan-400/70 group-hover:translate-x-0.5 transition-all"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            )}
          </button>
        ))}
      </div>

      {/* Zone 4 — Closing Wordmark */}
      <p className="text-[11px] tracking-[0.25em] text-white/20 uppercase font-light text-center pt-2 border-t border-white/5 shrink-0">
        built for you &mdash; owned by you &mdash; Tower
      </p>

    </div>
  </BaseBadge>
);

export default AboutBadge;
